var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Fragment, PureComponent } from "react";
import tracking from "@irati-tracking/recognition/recognition";
import Button from "@irati/ui/src/Button";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import CreateRecognition from "../Popup/CreateRecognition";
var RecogniseButton = /** @class */ (function (_super) {
    __extends(RecogniseButton, _super);
    function RecogniseButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFocus = function () {
            tracking.startCreateRecognition();
            _this.createPopup.show();
        };
        return _this;
    }
    RecogniseButton.prototype.render = function () {
        var _this = this;
        var large = this.props.large;
        return (React.createElement(Fragment, null,
            React.createElement(Button, { primary: true, large: large, onClick: this.handleFocus },
                React.createElement(FormattedMessage, { id: "recognition.banner.button" })),
            React.createElement(CreateRecognition, { ref: function (c) { _this.createPopup = c; } })));
    };
    return RecogniseButton;
}(PureComponent));
export default injectIntl(RecogniseButton);
